import { HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class ExternalDoctorService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';
        req.trash = req.trash || '';

        let requestUrl = environment.apiUrl + 'external-doctor/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter + "&trash=" + req.trash;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(branch){
        let requestUrl = environment.apiUrl + 'external-doctor/store';
        return this.http.post(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    edit(branch){
        let requestUrl = environment.apiUrl + 'external-doctor/update/' + branch.id;
        return this.http.put(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'external-doctor/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    restore(id){
        let requestUrl = environment.apiUrl + 'external-doctor/restore/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id, forceDelete){
        let requestUrl = environment.apiUrl + 'external-doctor/delete/' + id;
        if(forceDelete){
            requestUrl += '?forceDelete=1';
        }
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    addPatient(doctor_id, patient_id){
        let req = {
            doctor_id: doctor_id,
            patient_id: patient_id,
        }
        let requestUrl = environment.apiUrl + 'external-doctor/addPatient/';
        return this.http.post(requestUrl, req).map( (res: any) => {
            return res;
        });
    }
}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/external.doctor.service.ts